const regulations = {
  1: 'US Federal 60/7 Long Haul',
  2: 'US Federal 70/8 Long Haul',
  4: 'US Federal 60/7 Short Haul',
  5: 'US Federal 70/8 Short Haul',
  6: 'Alaska 70/7',
  7: 'Alaska 80/8',
  8: 'Texas 70/7',
  9: 'Florida 70/7',
  10: 'Florida 80/8',
  11: 'California 80/8',
  12: 'Canada Cycle1 70/7',
  13: 'Canada Cycle2 120/14',
  14: 'Mexico',
  18: 'US Pasngr 60/7',
  19: 'US Pasngr 70/8',
  20: 'USA Oilfield 70/8',
  21: 'Canada 60N Cycle1 80/7',
  22: 'Canada 60N Cycle2 120/14',
  23: 'US Federal 60/7 Long Haul',
  24: 'US Federal 70/8 Long Haul',
  25: 'US Federal 60/7 Short Haul',
  26: 'US Federal 70/8 Short Haul',
  27: 'Beta-US Federal 60/7 Long Haul',
  28: 'Beta-US Federal 70/8 Long Haul',
  29: 'Beta-US Federal 60/7 Short Haul',
  30: 'Beta-US Federal 70/8 Short Haul',
  31: 'US Federal 60/7 SH - No 30 Min Break',
  32: 'US Federal 70/8 SH - No 30 Min Break',
  33: 'Alberta 60S',
  34: 'Alberta 60N'
};

export default class Regulation {
  
  static forCurrent(identifierOrText) {
    const regulationName = regulations[identifierOrText];

    if (regulationName) {
      return regulationName;
    }

    return identifierOrText;
  }

}
